import { Card, Divider, Typography } from '@healthinal/ui';
import { EditScreeningTuberculosisHistoryForm } from './EditScreeningTuberculosisHistoryForm.tsx';

export function ScreeningTuberculosisHistoryCard({ individualId }: { individualId: string }) {
  return (
    <Card>
      <Typography level={'title-lg'}>Krankengeschichte</Typography>
      <Divider />
      <EditScreeningTuberculosisHistoryForm individualId={individualId} />
    </Card>
  );
}
